
import { i18nText } from '@/locales';
import { WarehouseUpdateRequestType } from "@/entity/warehouse/Warehouse";

export class StoreFormData {
    public id?: number | null | undefined;
    public name: string;
    public type_id: number | null;
    public salon_id: number | null;
    public comment: string;

    setFormData(data: WarehouseUpdateRequestType): void {
        this.id = data.id;
        this.name = data.name;
        this.type_id = data.type_id;
        this.salon_id = data.salon_id;
        this.comment = data.comment;
    }
    constructor(salon_id:number) {
        this.name = "";
        this.type_id = null;
        this.salon_id = salon_id;
        this.comment = "";
    }
}

export const StoreFormRules = {
    name: [{ required: true, message: i18nText("Пожалуйста укажите название"), trigger: "change" }],
    type_id: [{ required: true, message: i18nText("Пожалуйста выберите тип"), trigger: "change" }],
};
